define.alias("shared/utils/canvas-video-player", "settings/utils/canvas-video-player");